import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/not-found.tsx");
